export enum ApplicantTabEnum {
    PENDING = 'PENDING',
    SHORTLISTED = 'SHORTLISTED',
    NOT_A_MATCH = 'NOT_A_MATCH'
}

export enum ApplicantActionEnum {
    SHORTLIST = 'SHORTLIST',
    NOT_A_MATCH = 'NOT_A_MATCH'
}